/**
 * Schrittfolge des Telefonie-Wizards — EINE Quelle fuer Schrittleiste,
 * Vor/Zurueck, Express-Sprung und Fortsetzen-Dialog.
 *
 * ENTSCHEID Alex 01.10.2026 (Paket 1b, N1): der Schritt „Förderrechner"
 * entfaellt komplett. Nach „Interessentendaten" folgt direkt die
 * Zusammenfassung (Index 5). Bis dahin stand die Schrittzahl als nackte 6/7 an
 * vier Stellen (Store, Express-Sprung, Leiste, Dialogtext).
 */
export const WIZARD_SCHRITTE = [
  'haushalt', 'immobilie', 'absicherung', 'sparvertraege',
  'interessent', 'zusammenfassung',
] as const;

/** Index der Zusammenfassung (Buchungs-Schritt). */
export const LETZTER_WIZARD_SCHRITT = WIZARD_SCHRITTE.length - 1;

/**
 * Bringt einen Schritt-Index in den gueltigen Bereich.
 *
 * Traegt die gespeicherte Sitzung (`bw.wizard.sitzung`) aus der Zeit vor N1:
 * dort war 5 der Förderrechner (reine Anzeige, keine Eingabe) und 6 die
 * Zusammenfassung. Beide landen jetzt auf der Zusammenfassung — ohne
 * Klemme stuende der Wizard auf einem Index ohne Komponente und zeigte
 * unter der Schrittleiste nichts.
 */
export function klemmeWizardSchritt(schritt: unknown): number {
  if (typeof schritt !== 'number' || !Number.isFinite(schritt)) return 0;
  return Math.min(Math.max(Math.trunc(schritt), 0), LETZTER_WIZARD_SCHRITT);
}
